import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { USER_ROLES } from '../constants/roles'

const PrivateRoute = () => {
  const { session, role } = useContext(AuthContext)

  if (!session) return <Navigate to="/login" />

  if (role && role === USER_ROLES.USER) return <Navigate to="/" />

  return <Outlet />
}

export default PrivateRoute
